export type CardapioLocale = "pt" | "en" | "es";

export type CardapioI18nKey =
  | "nav.cart"
  | "nav.waiter"
  | "nav.account"
  | "nav.order"
  | "common.decrease"
  | "common.increase"
  | "promo.section"
  | "promo.add"
  | "product.add"
  | "product.quantity"
  | "product.obsLabel"
  | "product.obsPlaceholder"
  | "common.back"
  | "common.close"
  | "common.continue"
  | "common.subtotal"
  | "common.total"
  | "common.name"
  | "common.whatsapp"
  | "common.tableNumber"
  | "cart.existingTable"
  | "cart.addToTable"
  | "common.sending"
  | "common.remove"
  | "cart.title"
  | "cart.itemsSection"
  | "cart.empty"
  | "cart.placeOrder"
  | "cart.checkoutTitle"
  | "cart.checkoutSub"
  | "cart.sendKitchen"
  | "account.orders"
  | "account.closeAccount"
  | "account.empty"
  | "account.tableMode"
  | "account.individualMode"
  | "account.ordersOnTable"
  | "account.myOrders"
  | "account.tablePlaceholder"
  | "account.closeTable"
  | "account.closeMine"
  | "account.paymentTitle"
  | "account.paymentSub"
  | "account.payInPerson"
  | "success.orderTitle"
  | "success.backToMenu"
  | "wait.waiter"
  | "wait.requestSent"
  | "waiter.title"
  | "waiter.subInfo"
  | "waiter.subOptions"
  | "waiter.extraGlass"
  | "waiter.extraCutlery"
  | "waiter.extraPlate"
  | "waiter.clearTable"
  | "waiter.markOption"
  | "waiter.otherLabel"
  | "waiter.otherPlaceholder"
  | "waiter.request"
  | "errors.loadCatalog"
  | "errors.promoUnavailable"
  | "errors.qtyOverStock"
  | "errors.fillNameWhatsappTable"
  | "errors.sendOrder"
  | "errors.loadAccount"
  | "errors.selectItems"
  | "errors.closeIndividual"
  | "errors.closeAccount"
  | "errors.fillGarcom"
  | "errors.fillAllFields"
  | "errors.translation"
  | "errors.translationPartial";

const MESSAGES: Record<CardapioLocale, Record<CardapioI18nKey, string>> = {
  pt: {
    "nav.cart": "Carrinho",
    "nav.waiter": "Garçom",
    "nav.account": "Conta",
    "nav.order": "Pedir",
    "common.decrease": "Diminuir",
    "common.increase": "Aumentar",
    "promo.section": "Promoção",
    "promo.add": "Adicionar promoção",
    "product.add": "Adicionar",
    "product.quantity": "Quantidade",
    "product.obsLabel": "Quer fazer alguma observação?",
    "product.obsPlaceholder": 'Ex: Tirar item "X"',
    "common.back": "Voltar",
    "common.close": "Fechar",
    "common.continue": "Continuar",
    "common.subtotal": "Subtotal",
    "common.total": "Total:",
    "common.name": "Nome",
    "common.whatsapp": "Whatsapp",
    "common.tableNumber": "Nº Mesa",
    "cart.existingTable": "Já existe uma mesa aberta com essa identificação. Os itens serão adicionados a ela.",
    "cart.addToTable": "Adicionar à mesa",
    "common.sending": "Enviando…",
    "common.remove": "Remover",
    "cart.title": "Carrinho",
    "cart.itemsSection": "Seus itens",
    "cart.empty": "Seu carrinho está vazio.",
    "cart.placeOrder": "Fazer pedido",
    "cart.checkoutTitle": "Informações",
    "cart.checkoutSub": "Insira seus dados abaixo para realizar o pedido",
    "cart.sendKitchen": "Enviar para cozinha",
    "account.orders": "Pedidos",
    "account.closeAccount": "Fechar Conta",
    "account.empty": "Nenhum item encontrado.",
    "account.tableMode": "Mesa",
    "account.individualMode": "Individual",
    "account.ordersOnTable": "Pedidos na Mesa",
    "account.myOrders": "Meus Pedidos",
    "account.tablePlaceholder": "Número da mesa",
    "account.closeTable": "Fechar conta da mesa",
    "account.closeMine": "Fechar minha conta",
    "account.paymentTitle": "Pagamento",
    "account.paymentSub": "Qual a forma de pagamento?",
    "account.payInPerson": "Pagar presencial",
    "success.orderTitle": "Pedido realizado com sucesso",
    "success.backToMenu": "Voltar para o cardápio",
    "wait.waiter": "Aguarde o garçom",
    "wait.requestSent": "Solicitação enviada",
    "waiter.title": "Solicitar garçom",
    "waiter.subInfo": "Preencha seus dados para facilitar o atendimento do garçom",
    "waiter.subOptions": "Escolha uma das opções ou digite abaixo o que precisa",
    "waiter.extraGlass": "Copo Extra",
    "waiter.extraCutlery": "Talheres Extras",
    "waiter.extraPlate": "Prato Extra",
    "waiter.clearTable": "Limpar mesa",
    "waiter.markOption": "Marcar opção",
    "waiter.otherLabel": "Outras dúvidas/solicitações",
    "waiter.otherPlaceholder": "Oque você precisa?",
    "waiter.request": "Solicitar",
    "errors.loadCatalog": "Erro ao carregar cardápio",
    "errors.promoUnavailable": "Promoção indisponível",
    "errors.qtyOverStock": "Quantidade acima do disponível",
    "errors.fillNameWhatsappTable": "Preencha nome e mesa",
    "errors.sendOrder": "Erro ao enviar pedido",
    "errors.loadAccount": "Erro ao carregar conta",
    "errors.selectItems": "Selecione ao menos um item",
    "errors.closeIndividual": "Erro ao fechar conta individual",
    "errors.closeAccount": "Erro ao fechar conta",
    "errors.fillGarcom": "Preencha nome, mesa e escolha uma solicitação",
    "errors.fillAllFields": "Preencha todos os campos",
    "errors.translation": "Não foi possível traduzir o cardápio. Tente novamente.",
    "errors.translationPartial": "Alguns itens do cardápio não puderam ser traduzidos e permanecem em português.",
  },
  en: {
    "nav.cart": "Cart",
    "nav.waiter": "Waiter",
    "nav.account": "Bill",
    "nav.order": "Order",
    "common.decrease": "Decrease",
    "common.increase": "Increase",
    "promo.section": "Promotion",
    "promo.add": "Add promotion",
    "product.add": "Add",
    "product.quantity": "Quantity",
    "product.obsLabel": "Any special requests?",
    "product.obsPlaceholder": 'E.g.: Remove item "X"',
    "common.back": "Back",
    "common.close": "Close",
    "common.continue": "Continue",
    "common.subtotal": "Subtotal",
    "common.total": "Total:",
    "common.name": "Name",
    "common.whatsapp": "WhatsApp",
    "common.tableNumber": "Table No.",
    "cart.existingTable": "A table is already open with this name and number. The items will be added to it.",
    "cart.addToTable": "Add to table",
    "common.sending": "Sending…",
    "common.remove": "Remove",
    "cart.title": "Cart",
    "cart.itemsSection": "Your items",
    "cart.empty": "Your cart is empty.",
    "cart.placeOrder": "Place order",
    "cart.checkoutTitle": "Details",
    "cart.checkoutSub": "Enter your details below to place the order",
    "cart.sendKitchen": "Send to kitchen",
    "account.orders": "Orders",
    "account.closeAccount": "Close bill",
    "account.empty": "No items found.",
    "account.tableMode": "Table",
    "account.individualMode": "Individual",
    "account.ordersOnTable": "Table orders",
    "account.myOrders": "My orders",
    "account.tablePlaceholder": "Table number",
    "account.closeTable": "Close table bill",
    "account.closeMine": "Close my bill",
    "account.paymentTitle": "Payment",
    "account.paymentSub": "How would you like to pay?",
    "account.payInPerson": "Pay in person",
    "success.orderTitle": "Order placed successfully",
    "success.backToMenu": "Back to menu",
    "wait.waiter": "Please wait for the waiter",
    "wait.requestSent": "Request sent",
    "waiter.title": "Call waiter",
    "waiter.subInfo": "Fill in your details to help the waiter assist you",
    "waiter.subOptions": "Choose an option or type what you need below",
    "waiter.extraGlass": "Extra glass",
    "waiter.extraCutlery": "Extra cutlery",
    "waiter.extraPlate": "Extra plate",
    "waiter.clearTable": "Clear table",
    "waiter.markOption": "Select option",
    "waiter.otherLabel": "Other questions/requests",
    "waiter.otherPlaceholder": "What do you need?",
    "waiter.request": "Request",
    "errors.loadCatalog": "Failed to load menu",
    "errors.promoUnavailable": "Promotion unavailable",
    "errors.qtyOverStock": "Quantity exceeds available stock",
    "errors.fillNameWhatsappTable": "Fill in name and table",
    "errors.sendOrder": "Failed to send order",
    "errors.loadAccount": "Failed to load bill",
    "errors.selectItems": "Select at least one item",
    "errors.closeIndividual": "Failed to close individual bill",
    "errors.closeAccount": "Failed to close bill",
    "errors.fillGarcom": "Fill in name, table and choose a request",
    "errors.fillAllFields": "Fill in all fields",
    "errors.translation": "Could not translate the menu. Please try again.",
    "errors.translationPartial": "Some menu items could not be translated and remain in Portuguese.",
  },
  es: {
    "nav.cart": "Carrito",
    "nav.waiter": "Camarero",
    "nav.account": "Cuenta",
    "nav.order": "Pedir",
    "common.decrease": "Disminuir",
    "common.increase": "Aumentar",
    "promo.section": "Promoción",
    "promo.add": "Añadir promoción",
    "product.add": "Añadir",
    "product.quantity": "Cantidad",
    "product.obsLabel": "¿Alguna observación?",
    "product.obsPlaceholder": 'Ej.: Quitar el ítem "X"',
    "common.back": "Volver",
    "common.close": "Cerrar",
    "common.continue": "Continuar",
    "common.subtotal": "Subtotal",
    "common.total": "Total:",
    "common.name": "Nombre",
    "common.whatsapp": "WhatsApp",
    "common.tableNumber": "Nº Mesa",
    "cart.existingTable": "Ya existe una mesa abierta con esta identificación. Se le añadirán los productos.",
    "cart.addToTable": "Añadir a la mesa",
    "common.sending": "Enviando…",
    "common.remove": "Eliminar",
    "cart.title": "Carrito",
    "cart.itemsSection": "Tus artículos",
    "cart.empty": "Tu carrito está vacío.",
    "cart.placeOrder": "Hacer pedido",
    "cart.checkoutTitle": "Información",
    "cart.checkoutSub": "Ingresa tus datos para realizar el pedido",
    "cart.sendKitchen": "Enviar a cocina",
    "account.orders": "Pedidos",
    "account.closeAccount": "Cerrar cuenta",
    "account.empty": "No se encontraron artículos.",
    "account.tableMode": "Mesa",
    "account.individualMode": "Individual",
    "account.ordersOnTable": "Pedidos de la mesa",
    "account.myOrders": "Mis pedidos",
    "account.tablePlaceholder": "Número de mesa",
    "account.closeTable": "Cerrar cuenta de la mesa",
    "account.closeMine": "Cerrar mi cuenta",
    "account.paymentTitle": "Pago",
    "account.paymentSub": "¿Cuál es la forma de pago?",
    "account.payInPerson": "Pagar en persona",
    "success.orderTitle": "Pedido realizado con éxito",
    "success.backToMenu": "Volver al menú",
    "wait.waiter": "Espere al camarero",
    "wait.requestSent": "Solicitud enviada",
    "waiter.title": "Solicitar camarero",
    "waiter.subInfo": "Complete sus datos para facilitar la atención del camarero",
    "waiter.subOptions": "Elija una opción o escriba lo que necesita abajo",
    "waiter.extraGlass": "Vaso extra",
    "waiter.extraCutlery": "Cubiertos extra",
    "waiter.extraPlate": "Plato extra",
    "waiter.clearTable": "Limpiar mesa",
    "waiter.markOption": "Marcar opción",
    "waiter.otherLabel": "Otras dudas/solicitudes",
    "waiter.otherPlaceholder": "¿Qué necesitas?",
    "waiter.request": "Solicitar",
    "errors.loadCatalog": "Error al cargar el menú",
    "errors.promoUnavailable": "Promoción no disponible",
    "errors.qtyOverStock": "Cantidad superior al disponible",
    "errors.fillNameWhatsappTable": "Complete nombre y mesa",
    "errors.sendOrder": "Error al enviar el pedido",
    "errors.loadAccount": "Error al cargar la cuenta",
    "errors.selectItems": "Seleccione al menos un artículo",
    "errors.closeIndividual": "Error al cerrar la cuenta individual",
    "errors.closeAccount": "Error al cerrar la cuenta",
    "errors.fillGarcom": "Complete nombre, mesa y elija una solicitud",
    "errors.fillAllFields": "Complete todos los campos",
    "errors.translation": "No fue posible traducir el menú. Inténtelo de nuevo.",
    "errors.translationPartial": "Algunos elementos del menú no pudieron traducirse y permanecen en portugués.",
  },
};

const COMANDA_MESSAGES: Record<CardapioLocale, Partial<Record<CardapioI18nKey, string>>> = {
  pt: {
    "common.tableNumber": "Nº Comanda",
    "cart.existingTable": "Já existe uma comanda aberta com essa identificação. Os itens serão adicionados a ela.",
    "cart.addToTable": "Adicionar à comanda",
    "account.tableMode": "Comanda",
    "account.ordersOnTable": "Pedidos na Comanda",
    "account.tablePlaceholder": "Número da comanda",
    "account.closeTable": "Fechar conta da comanda",
    "errors.fillNameWhatsappTable": "Preencha nome e comanda",
    "errors.fillGarcom": "Preencha nome, comanda e escolha uma solicitação",
  },
  en: {
    "common.tableNumber": "Tab No.",
    "cart.existingTable": "A tab is already open with this name and number. The items will be added to it.",
    "cart.addToTable": "Add to tab",
    "account.tableMode": "Tab",
    "account.ordersOnTable": "Tab orders",
    "account.tablePlaceholder": "Tab number",
    "account.closeTable": "Close tab bill",
    "errors.fillNameWhatsappTable": "Fill in name and tab",
    "errors.fillGarcom": "Fill in name, tab and choose a request",
  },
  es: {
    "common.tableNumber": "Nº Comanda",
    "cart.existingTable": "Ya existe una comanda abierta con esta identificación. Se le añadirán los productos.",
    "cart.addToTable": "Añadir a la comanda",
    "account.tableMode": "Comanda",
    "account.ordersOnTable": "Pedidos de la comanda",
    "account.tablePlaceholder": "Número de comanda",
    "account.closeTable": "Cerrar cuenta de la comanda",
    "errors.fillNameWhatsappTable": "Complete nombre y comanda",
    "errors.fillGarcom": "Complete nombre, comanda y elija una solicitud",
  },
};

export function cardapioT(locale: CardapioLocale, key: CardapioI18nKey, modoAtendimento: "mesa" | "comanda" | "ambos" = "mesa"): string {
  if (modoAtendimento !== "mesa" && COMANDA_MESSAGES[locale][key]) {
    return COMANDA_MESSAGES[locale][key]!;
  }
  return MESSAGES[locale][key] ?? MESSAGES.pt[key] ?? key;
}
